class MainHeader extends HTMLElement {
  constructor() {
    super();

    this.header = this.querySelector("header");
    // console.log("header", this.header.clientHeight);

    this.bodyContent = document.querySelector("#MainContent");
    // this.bodyContent.style.marginTop = this.header.clientHeight + "px";

    // Nav Links
    this.onNavClick = this.handleNavClick.bind(this);

    this.navLinks = this.querySelectorAll(".nav-link.has-submenu");
    this.flyoutMenus = this.querySelectorAll(".js-flyout-menu");

    this.navLinks.forEach((link) => {
      // console.log("link", link);
      link.addEventListener("click", this.onNavClick);
    });
  }

  closeFlyoutMenus() {
    this.flyoutMenus.forEach((menu) => {
      menu.classList.remove("flyout-menu-open");
      menu.classList.add("flyout-menu-close");
    });
  }

  handleNavClick(evt) {
    const btn = evt.target;

    const menu = this.querySelector(`#flyout-menu-${btn.dataset.handle}`);
    if (!menu.classList.contains("flyout-menu-open")) {
      this.closeFlyoutMenus();
      menu.classList.add("flyout-menu-open");
    } else {
      this.closeFlyoutMenus();
    }
  }
}

customElements.define("main-header", MainHeader);
